import {
  Button,
  ButtonGroup,
  Dropdown,
  H3,
  Input,
  Stack
} from "@adfenix/alexandria";
import { createCustomTrigger } from "api/services/programService";
import Divider from "components/Divider";
import { Modal } from "components/Modal";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { availableTriggersQueryKey } from ".";
import { SUPPORTED_PROGRAM_SUBJECT_TYPES } from "utils/constants";
import { ProgramService } from "@adfenix/types";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  hqId: string;
}
export const CreateTriggerModal = ({ show, setShow, hqId }: Props) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const [triggerName, setTriggerName] = useState("");
  const [subjectType, setSubjectType] =
    useState<ProgramService.SubjectType>("Property");
  const { isLoading, mutate } = useMutation(createCustomTrigger, {
    onSuccess: () => {
      queryClient.invalidateQueries([availableTriggersQueryKey]);
      setShow(false);
    },
    onError: () => {
      toast.error(t("login.error.generic.title"));
    }
  });

  return (
    <Modal show={show} onClose={() => setShow(false)}>
      <Modal.Card style={{ padding: "16px" }}>
        <H3>Create trigger</H3>
        <Divider margin="24px 0" />

        <Stack spacing="m">
          <Input
            label="Name"
            id="trigger-name"
            onChange={e => setTriggerName(e.target.value)}
          />

          <Dropdown
            label="Subject type"
            id="trigger-subject-type"
            items={SUPPORTED_PROGRAM_SUBJECT_TYPES}
            onChange={setSubjectType}
            defaultValue={subjectType}
          />
        </Stack>

        <Divider margin="24px 0" />
        <ButtonGroup justifyContent="end">
          <Button
            logLabel="modal-cancel-create-trigger-button"
            variant="secondary"
            disabled={isLoading}
            onClick={() => {
              setTriggerName("");
              setShow(false);
            }}
          >
            Cancel
          </Button>
          <Button
            logLabel="modal-create-trigger-button"
            onClick={() =>
              mutate({
                hqId,
                name: triggerName,
                targetSubjectType: subjectType
              })
            }
            isLoading={isLoading}
          >
            Create
          </Button>
        </ButtonGroup>
      </Modal.Card>
    </Modal>
  );
};
